let bAuthLoaded = false; /**WEBMESS-540: boolean variable to determine if the Auth plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

function initAuth(config, GenesysJS) {
  const auth = config.deploymentConfig.auth||{};

  if (auth && auth.enabled === true) {
    if (!bAuthLoaded) {
      bAuthLoaded = true;
      GenesysJS.log('Authentication enabled. Loading Auth plugin.');

      GenesysJS.subscribe('Auth.ready', () => {
        GenesysJS.command('Auth.configure', config);
      });
    }
  }
}

export default initAuth;
